var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:(_vm.tooltipContent),expression:"tooltipContent"}],staticClass:"role-limit-badge",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.current)+"/"+_vm._s(_vm.limit)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }